export default __webpack_public_path__ + "static/media/marker-blue.7503029c.png";